import type { MoveJudgement, MoveRecord } from "../utils/gameReportUtils";

type Edges = Record<string, { edges: Record<string, number> }>;

/**
 * The move-history entry for one move: the move's choice flags plus what
 * achievements need later, once a backtrack may have cut it from the path.
 * `localOptimalRouteFromChoice` is the Local Optimal route from the chosen
 * word (empty when it is the target or unreachable).
 */
export function buildMoveRecord(
  choice: MoveJudgement,
  graph: Edges,
  frequencies: Record<string, number> | null,
  targetWord: string,
  localOptimalRouteFromChoice: string[],
): MoveRecord {
  const record: MoveRecord = { ...choice };
  record.hopsFromChoiceToEnd =
    choice.playerChose === targetWord
      ? 0
      : localOptimalRouteFromChoice.length - 1;
  if (frequencies) {
    const offered = Object.keys(graph[choice.playerPosition]?.edges ?? {})
      .map((w) => frequencies[w])
      .filter((f): f is number => typeof f === "number" && Number.isFinite(f));
    if (offered.length > 0)
      record.rarestOfferedFrequency = Math.min(...offered);
  }
  return record;
}
